import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Badge as BaseBadge, withStyles } from '@material-ui/core';

import { getAppUIVariantConfig } from 'Util/uiVariantSet';

import Colors from '../../Theme/colors';
import { Box, Flex, SvgIcon } from '../../Base';

const BadgeContainer = styled(Box)`
  cursor: pointer;
`;

const Badge = ({ outlined, ...props }) => {
  const position = outlined
    ? {
        top: '3px',
        right: '0px',
        left: '5px',
      }
    : {
        top: '-1px',
        right: '2px',
      };
  const StyledBadge = withStyles(() => ({
    badge: {
      backgroundColor: Colors.badge,
      color: Colors.white,
      ...position,
    },
  }))(BaseBadge);

  return <StyledBadge {...props} />;
};

const NotifyIcon = ({ onClick, bg, color, outlined }) => {
  const { Notification: NotificationStyle } = getAppUIVariantConfig();

  switch (NotificationStyle) {
    case 'Outlined': {
      return (
        <Flex
          justifyContent={'center'}
          alignItems={'center'}
          p={outlined ? 0 : '3px'}
          onClick={onClick}
          bg={bg ?? 'blacks.4'}
          style={{ borderRadius: '50%' }}
        >
          <SvgIcon
            icon={SvgIcon.ICON_LIST.NOTIFICATION_OUTLINED}
            size={24}
            color={color ?? 'primary'}
          />
        </Flex>
      );
    }
    case 'Filled':
    default: {
      return (
        <Flex
          justifyContent={'center'}
          alignItems={'center'}
          p={outlined ? 0 : '3px'}
          onClick={onClick}
          bg={bg ?? 'rgba(72, 142, 255, 0.5)'}
          style={{ borderRadius: '50%' }}
        >
          <SvgIcon icon={SvgIcon.ICON_LIST.NOTIFICATION} size={24} color={color} />
        </Flex>
      );
    }
  }
};

const NotificationIcon = ({ unreadNo, onClick, bg, color, outlined }) => {
  return (
    <BadgeContainer>
      <Badge badgeContent={unreadNo} showZero={false} overlap="circular" outlined={outlined}>
        <NotifyIcon onClick={onClick} bg={bg} color={color} outlined={outlined} />
      </Badge>
    </BadgeContainer>
  );
};

NotificationIcon.propTypes = {
  unreadNo: PropTypes.number,
  onClick: PropTypes.func,
  bg: PropTypes.string,
  color: PropTypes.string,
  outlined: PropTypes.bool,
};

NotificationIcon.defaultProps = {
  unreadNo: 0,
  onClick: null,
  color: 'white',
  outlined: false,
};

export default NotificationIcon;
